import AdminTable from "./AdminTable";

export default AdminTable;